import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Common";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [state, setState] = useState({ busy: false, error: "", done: false });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, error: "", done: false });
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      setState({ busy: false, error: "", done: true });
    } catch (err) {
      setState({ busy: false, error: errMsg(err), done: false });
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="glass glow w-full max-w-md p-8" data-testid="reset-password-page">
        <Logo sub />
        <h1 className="mt-6 text-2xl font-bold text-white">Neues Passwort festlegen</h1>
        {state.done ? (
          <div className="mt-6 space-y-4">
            <p data-testid="reset-success" className="text-emerald-300 text-sm">Passwort geändert. Du kannst dich jetzt anmelden.</p>
            <Link to="/login" className="btn-grad inline-block px-5 py-2.5" data-testid="reset-go-login">Zum Login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input data-testid="reset-password-input" type="password" minLength={8} required className="field" placeholder="Mindestens 8 Zeichen" value={pw} onChange={(e) => setPw(e.target.value)} />
            {state.error && <div data-testid="reset-error" className="text-sm text-red-300">{state.error}</div>}
            <button disabled={state.busy} data-testid="reset-submit-button" className="btn-grad w-full py-3">Passwort speichern</button>
          </form>
        )}
      </div>
    </div>
  );
}
